module.exports = __webpack_public_path__ + "img/collapse-left.a93a00ab.svg";